<button
  nbButton
  ghost
  status="primary"
  size="small"
  (click)="goBack()"
  class="back-button"
>
  <nb-icon icon="arrow-back-outline"></nb-icon>
  Back to GWAS Studies
</button>

<div *ngIf="isLoading" class="loading-container">
  <ngx-spinner
    color="#D73647"
    bdColor="#00000050"
    [fullScreen]="true"
    size="large"
  >
    <div>Loading GWAS 1-5 Study...</div>
  </ngx-spinner>
</div>

<div *ngIf="error" class="error-container">
  <div class="error-message">
    <h2>Unable to load GWAS 1-5 Study</h2>
    <p>{{ error.status }}: {{ error.message }}</p>
    <p class="redirect-notice">Redirecting to homepage...</p>
    <button nbButton status="primary" (click)="goBack()">
      Go Back Now
    </button>
  </div>
</div>

<div *ngIf="plotSrc && !isLoading && !error" class="iframe-container">
  <iframe [src]="plotSrc" scrolling="no"></iframe>
</div>
